module.exports = __webpack_public_path__ + "media/images/product/p_o-aefebc56fd8379f52219a3ed7f658c5e.png";